var map = {
	"./add.svg": 726,
	"./all.svg": 727,
	"./arrow.svg": 728,
	"./arrow_top.svg": 1447,
	"./check.svg": 382,
	"./client.svg": 723,
	"./close.svg": 729,
	"./communication.svg": 1448,
	"./copy.svg": 1449,
	"./cross.svg": 211,
	"./delete.svg": 255,
	"./export.svg": 1450,
	"./green_check.svg": 1451,
	"./iconAdd.svg": 1452,
	"./iconChat.svg": 1453,
	"./message.svg": 730,
	"./orders.svg": 731,
	"./pancil.svg": 380,
	"./payment.svg": 732,
	"./refresh.svg": 733,
	"./scheduled-message.svg": 734,
	"./star.svg": 1454,
	"./star_active.svg": 1455,
	"./unlock.svg": 1456,
	"./warning.svg": 1457,
	"./warning_crm.svg": 644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1446;